<template>
  <div>
    <div class="modal-card" style="width: auto">
      <header class="modal-card-head">
        <p class="modal-card-title">Formação Continuada</p>
      </header>
      <section class="modal-card-body py-8" style="text-transform: none">
        <p>
          Acompanhe os cursos de <b>Formação Continuada</b> pelo blog da plataforma Psyservice e mídias digitais!
        </p>
        <p>
          Lembre-se, <b>Profissionais Premium </b>têm excelentes descontos!<br/>
          Todos os cursos com emissão de certificado!
        </p>
      </section>
      <footer class="modal-card-foot">
        <button class="button" type="button" @click="$parent.close()">Cancelar</button>
      </footer>
    </div>
  </div>
</template>

<script>
export default {}
</script>
